import React from 'react'
import { Router } from '@reach/router'
import moment from 'moment'
import momentLocale from 'moment/locale/pl'

import Login from '../containers/Login'
import PrivateRoute from '../components/PrivateRoute'
import Patients from '../containers/PatientsList/PatientsList'
import Patient from '../containers/Patient/index'
import AddPatient from '../containers/Patient/AddPatient'
import Reports from '../containers/Reports/ReportsList'
import Inquiry from '../containers/Inquiry/InquiryPanel'
import Report from '../containers/ReportsGen/Report'
import Statistics from '../containers/Statistics/Statistics'
import SurveyList from '../containers/Surveys/SurveyList'
import AddSurvey from '../containers/Surveys/AddSurvey'
import EditSurvey from '../containers/Surveys/EditSurvey'
import SurveyPreview from '../containers/Surveys/SurveyPreview'
import SendSurvey from '../containers/Surveys/SendSurvey'
import SurveyStatus from '../containers/Surveys/SurveyStatus'
import UnitsWaypoint from '../components/Units/UnitsWaypoint'
import NewUnit from '../components/Units/NewUnit'
import UnitsTabPanel from '../components/Units/UnitsTabPanel'
import EditUnit from '../components/Units/EditUnit'
import { AppSidePanel } from '../components/SidePanel/SidePanel'
import PostDiagnosticList from '../containers/PostDiagnostic/PostDiagnosticList'
import Home from '../containers/Dashboard/index'
import AddUser from '../containers/Users/AddUser'
import EditUser from '../containers/Users/EditUser'

import UserList from '../containers/Users/UserList'
import App from '../containers/App'
import { NotificationProvider } from '../containers/Notifications'
import { permissions as p } from '../utils/constants'

import 'react-datepicker/dist/react-datepicker.css'
import '../i18n'

moment.locale('pl', momentLocale)

const Main = (props) => (
  <NotificationProvider>
    <App.Provider>
      <AppSidePanel />
      <Router>
        <Login location={props.location} path="app/login/*" />

        <PrivateRoute path="/app" component={Home} />
        <PrivateRoute
          path="/app/patients"
          component={Patients}
          permissions={[p.diagnostician]}
          exact
        />
        <PrivateRoute
          path="/app/patients/add"
          component={AddPatient}
          permissions={[p.diagnostician]}
        />
        <PrivateRoute
          path="/app/patients/:id/inquiry"
          component={Inquiry}
          permissions={[p.diagnostician]}
        />
        <PrivateRoute
          path="/app/patients/:id"
          component={Patient}
          location={props.location}
          permissions={[p.diagnostician]}
        />

        <PrivateRoute
          path="/app/reports"
          component={Reports}
          permissions={[p.reportList]}
        />

        <PrivateRoute
          path="/app/users"
          component={UserList}
          exact
          permissions={[p.userAccess]}
        />
        <PrivateRoute
          path="/app/users/add"
          component={AddUser}
          permissions={[p.userAccess]}
        />
        <PrivateRoute
          path="/app/users/:id"
          component={EditUser}
          location={props.location}
          permissions={[p.userEditor]}
        />
        <PrivateRoute
          path="/app/patients/:id/report"
          component={Report}
          location={props.location}
          permissions={[p.reportAccess]}
        />
        <PrivateRoute
          path="/app/units"
          component={UnitsWaypoint}
          permissions={[p.diagnosticiansManagement]}
        />
        <PrivateRoute
          path="/app/units/panel/:id"
          component={UnitsTabPanel}
          permissions={[p.diagnosticiansManagement, p.diagnostician]}
        />
        <PrivateRoute
          path="/app/units/add"
          component={NewUnit}
          permissions={[p.unitManagement]}
        />
        <PrivateRoute
          path="/app/units/:id"
          component={EditUnit}
          location={props.location}
          permissions={[p.unitManagement]}
        />
        <PrivateRoute
          path="/app/post-diagnostic"
          component={PostDiagnosticList}
          location={props.location}
          permissions={[p.diagnostician]}
        />
        <PrivateRoute
          path="/app/surveys"
          component={SurveyList}
          permissions={[p.reportList]}
        />
        <PrivateRoute
          path="/app/surveys/add"
          component={AddSurvey}
          permissions={[p.reportList]}
        />
        <PrivateRoute
          path="/app/surveys/:id"
          component={EditSurvey}
          permissions={[p.reportList]}
        />
        <PrivateRoute
          path="/app/surveys/send/:id"
          component={SendSurvey}
          permissions={[p.reportList]}
        />
        <PrivateRoute
          path="/app/surveys/info/:id"
          component={SurveyStatus}
          permissions={[p.reportList]}
        />
        <PrivateRoute
          path="/app/preview/:id"
          component={SurveyPreview}
          permissions={[p.reportList]}
        />
        <PrivateRoute
          path="/app/statistics"
          component={Statistics}
          permissions={[p.diagnosticiansManagement]}
        />
      </Router>
    </App.Provider>
  </NotificationProvider>
)

export default Main
